import { generatePath } from 'react-router-dom';
import { DEV_PDF_REPORT_ROUTE } from '~/_shared/constants/routes';
import type {
  ExportReportActiveParams, ExportReportSettings,
} from '~/store/mapSettings/toolsState/exportReport/exportReportToolState.state';

const DEV_PDF_REPORT_STORAGE_KEY_PREFIX = 'DEV_PDF_REPORT_STATE_';

export type DevExportReportSnapshot = Readonly<{
  params: ExportReportActiveParams;
  settings: ExportReportSettings;
}>;

const getStorageKey = (mapId: number) => `${DEV_PDF_REPORT_STORAGE_KEY_PREFIX}${mapId}`;

export const saveDevExportReportSnapshot = (mapId: number, snapshot: DevExportReportSnapshot) => {
  localStorage.setItem(getStorageKey(mapId), JSON.stringify(snapshot));
};

export const loadDevExportReportSnapshot = (mapId: number): DevExportReportSnapshot | null => {
  const storedSnapshot = localStorage.getItem(getStorageKey(mapId));
  if (!storedSnapshot) {
    return null;
  }

  try {
    return JSON.parse(storedSnapshot) as DevExportReportSnapshot;
  }
  catch {
    return null;
  }
};

export const getDevPdfReportPath = (mapId: number) => generatePath(DEV_PDF_REPORT_ROUTE, { mapId: mapId.toString() });
